import { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import AvatarPlaceholder from '../../assets/auth/register/avatar-placeholder.png';
import { useDispatch } from 'react-redux';
import { uploadAvatar } from '../../store/user/userActions';
import { Spinner } from '../global/spinner';

const AvatarInput = ({ name, register, errors, required, setValue, defaultValue }) => {
	const hiddenFileInput = useRef(null);
	const dispatch = useDispatch();

	const [preview, setPreview] = useState(null);
	const [isUploading, setIsUploading] = useState(false);
	const [avatarUrl, setAvatarUrl] = useState(AvatarPlaceholder);
	const [localError, setLocalError] = useState(null);

	const {ref, ...rest} = register(name)
	useEffect(() => {
		let newUrl;
		if (preview) {
			newUrl = URL.createObjectURL(preview);
		} else if (!isUploading && defaultValue) {
			newUrl = process.env.REACT_APP_BACKEND_URL + defaultValue;
		} else {
			newUrl = AvatarPlaceholder;
		}

		setAvatarUrl(prev => {
			if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev);
			return newUrl;
		});
	}, [preview, isUploading, defaultValue]);

	const handleClick = useCallback(() => {
		hiddenFileInput.current?.click();
	}, []);

	const handleSelectFile = useCallback((e) => {
		const file = e.target.files?.[0];
		setLocalError(null);

		if (!file) return;

		// Client-side validation
		if (file.size / 1024 > 5000) {
			setLocalError("File size must be less than 5MB");
			return;
		}

		setIsUploading(true);
		setPreview(file);
		console.log(file)
		setValue(name, [file])
		dispatch(uploadAvatar({ avatar: file }))
			.unwrap()
			.then((v) => {
				console.log(name, v.id)

				setValue("avatarId", v.id, { shouldValidate: true });
				setIsUploading(false);
			})
			.catch((error) => {
				setLocalError(error.message || "Upload failed");
				setIsUploading(false);
			});
	}, [dispatch]);

	return (
		<div className="relative w-full h-full">
			<div className="relative text-center select-none">
				<img
					onClick={handleClick}
					className={`mx-auto cursor-pointer rounded-full w-[100px] h-[100px] object-cover ${isUploading ? "opacity-50" : ""}`}
					src={avatarUrl}
					alt="Avatar"
				/>
				{isUploading ? <div className='absolute z-50 w-full top-[38px]'>
					<Spinner className="" />
				</div> : null}
			</div>

			<input
				id={name}
				name={name}
				type="file"
				accept="image/*"
				style={{ display: "none" }}
				{...register(name)}
				onChange={handleSelectFile}
				ref={(e) => {
					ref(e);
					hiddenFileInput.current = e;
				}}
			/>
			<input type='hidden' {...register("avatarId", {
				validate: {
					required: (data) => {
						if ((data == null || data.length === 0) && !defaultValue) {
							return "This Field is required";
						}
						return true
					}
				}
			})} />
			<span className="text-center error">
				{errors?.["avatarId"]?.message || errors?.[name]?.message}
			</span>
		</div>
	);
};

export { AvatarInput };